const readStoredCollapsed = () => {
    try {
        return localStorage.getItem('ui.sidebarCollapsed') === '1'
    } catch (e) {
        return false
    }
}

export default {
    isSidebarCollapsed: readStoredCollapsed(),
    isMobileMenuOpen: false
}
